import { IDEITableSearchParams } from "src/Interfaces/deltaHedgeBackTest";
import { getDEITable } from "src/Requests/deltaHedgeBackTest";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";

interface IProps {
  searchParams: IDEITableSearchParams;
}

const DEITable = ({ searchParams }: IProps) => {
  return (
    <TableTemplate
      TableUI={({ reports }) => <CommonTableUI reports={reports} />}
      getDataTable={getDEITable}
      searchParameters={searchParams}
    />
  );
};

export default DEITable;
